module.exports = __webpack_public_path__ + "dca1d04764d25fc2134c3241d6e53cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/es.png
// module id = 1057
// module chunks = 0